import style from './Movie.module.scss'
import axios from 'axios';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import MovieTitle from './movieTitle/MovieTitle';
import MovieSubtitle from './movieSubtitle/MovieSubtitle';
import { setMovie, setSimilar, setStatus } from '../../../redux/movieSlices/MovieSlices';
import Preloader from '../../preloader/Preloader';
import { selectMovie } from '../../../redux/movieSlices/MovieSelector'

let Movie = () => {

    const dispatch = useDispatch()

    const id = useParams()

    let { movie, status } = useSelector(selectMovie)

    useEffect(() => {
        dispatch(setStatus('loading'))
        axios.get(`https://yts.mx/api/v2/movie_details.json?movie_id=${id.filmId}&with_images=true&with_cast=true`, {
        })
            .then(response => {
                console.log(response)
                dispatch(setMovie(response.data.data.movie))
                dispatch(setStatus('completed'))
            })
    }, []);

    useEffect(() => {
        axios.get(`https://yts.mx/api/v2/movie_suggestions.json?movie_id=${id.filmId}`, {
        })
            .then(response => {
                dispatch(setSimilar(response.data.data.movies))
            })
    }, []);

    var yt_trailer: string = '';

    if (movie.yt_trailer_code) {
        let baseAPI: string = 'https://www.youtube.com/embed/'
        var yt_trailer = baseAPI + movie.yt_trailer_code
    }

    return (
        <>
            {status === 'completed'
                ?
                <div className={style.movie}>
                    <div className={style.movie__container}>
                        <MovieTitle />
                        <MovieSubtitle yt_trailer={yt_trailer} />
                    </div >
                </div>
                :
                <Preloader />}
        </>
    )
}

export default Movie;